var _rect, _rect2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProductivityimg9(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 79,
    height: 79,
    rx: 39.5,
    fill: "url(#paint0_linear_852_1273)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 79,
    height: 79,
    rx: 39.5,
    stroke: "url(#paint1_linear_852_1273)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_852_1273)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.6667 41.9919C54.6629 42.343 54.5208 42.6785 54.2711 42.9254C54.0215 43.1724 53.6845 43.3109 53.3334 43.3109C52.9822 43.3109 52.6452 43.1724 52.3956 42.9254C52.146 42.6785 52.0038 42.343 52 41.9919V30C52.0038 29.6489 52.146 29.3134 52.3956 29.0665C52.6452 28.8195 52.9822 28.681 53.3334 28.681C53.6845 28.681 54.0215 28.8195 54.2711 29.0665C54.5208 29.3134 54.6629 29.6489 54.6667 30V41.9919ZM54.2014 50.3377C53.9953 50.5141 49.0561 54.6588 40 54.6588C30.9441 54.6588 26.005 50.5139 25.7989 50.3375C25.5305 50.1073 25.3644 49.7799 25.3373 49.4274C25.3102 49.0748 25.4243 48.7259 25.6544 48.4573C25.884 48.1893 26.2106 48.0232 26.5625 47.9956C26.9143 47.968 27.2628 48.0811 27.5314 48.3102C27.6097 48.3758 32.0203 51.9919 40.0002 51.9919C48.0802 51.9919 52.4225 48.3497 52.4655 48.313C53.0234 47.8338 53.8667 47.8981 54.3456 48.4575C54.5758 48.726 54.6899 49.0749 54.6629 49.4274C54.6358 49.78 54.4698 50.1075 54.2014 50.3377ZM25.3333 30C25.3371 29.6489 25.4792 29.3134 25.7289 29.0665C25.9785 28.8195 26.3155 28.681 26.6666 28.681C27.0178 28.681 27.3548 28.8195 27.6044 29.0665C27.854 29.3134 27.9962 29.6489 28 30V41.9919C27.9962 42.343 27.854 42.6785 27.6044 42.9254C27.3548 43.1724 27.0178 43.3109 26.6666 43.3109C26.3155 43.3109 25.9785 43.1724 25.7289 42.9254C25.4792 42.6785 25.3371 42.343 25.3333 41.9919V30ZM32.0002 27.3333C32.0055 26.9832 32.1483 26.6493 32.3978 26.4036C32.6473 26.158 32.9833 26.0203 33.3334 26.0203C33.6836 26.0203 34.0196 26.158 34.2691 26.4036C34.5185 26.6493 34.6614 26.9832 34.6667 27.3333V45.1459C34.6614 45.496 34.5185 45.8299 34.2691 46.0756C34.0196 46.3213 33.6836 46.459 33.3334 46.459C32.9833 46.459 32.6473 46.3213 32.3978 46.0756C32.1483 45.8299 32.0055 45.496 32.0002 45.1459V27.3333ZM38.6667 26.6586C38.6667 26.4835 38.7012 26.3101 38.7682 26.1483C38.8352 25.9866 38.9334 25.8396 39.0572 25.7158C39.181 25.592 39.328 25.4938 39.4898 25.4268C39.6515 25.3598 39.8249 25.3253 40 25.3253C40.1751 25.3253 40.3485 25.3597 40.5103 25.4267C40.6721 25.4937 40.8191 25.5919 40.9429 25.7157C41.0667 25.8395 41.165 25.9865 41.232 26.1483C41.299 26.3101 41.3335 26.4835 41.3334 26.6586V45.9919C41.3296 46.343 41.1875 46.6785 40.9378 46.9254C40.6882 47.1724 40.3512 47.3109 40.0001 47.3109C39.6489 47.3109 39.312 47.1724 39.0623 46.9254C38.8127 46.6785 38.6705 46.343 38.6667 45.9919V26.6586ZM45.3334 27.3333C45.3388 26.9832 45.4816 26.6493 45.7311 26.4036C45.9805 26.158 46.3166 26.0203 46.6667 26.0203C47.0168 26.0203 47.3529 26.158 47.6024 26.4036C47.8518 26.6493 47.9946 26.9832 48 27.3333V45.1459C47.9946 45.496 47.8518 45.8299 47.6024 46.0756C47.3529 46.3213 47.0168 46.459 46.6667 46.459C46.3166 46.459 45.9805 46.3213 45.7311 46.0756C45.4816 45.8299 45.3388 45.496 45.3334 45.1459V27.3333ZM55 20H25C22.2386 20 20 22.2386 20 25V55C20 57.7613 22.2386 60 25 60H55C57.7614 60 60 57.7613 60 55V25C60 22.2386 57.7614 20 55 20Z",
    fill: "#A6A6C9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_852_1273",
    x1: 40,
    y1: 0,
    x2: 40,
    y2: 80,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#05050F",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D8DB9",
    stopOpacity: 0.16
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_852_1273",
    x1: 40,
    y1: 0,
    x2: 40,
    y2: 80,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D8DB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#27273F"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_852_1273"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(20 20)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductivityimg9);
export default __webpack_public_path__ + "static/media/productivityimg9.26f94e5da01fa6b6f95932073d9db38f.svg";
export { ForwardRef as ReactComponent };